module.exports = __webpack_public_path__ + "media/images/background_home_2480-520w-42f9cb8b.jpg";